import { useQuery } from "react-query";

import { makeSimpleGetRequest, makeSimplePostRequest } from "lib/axios";
import { ORDERBOOK_URL } from "services/constants";

import { CreateRelistRequestPayload, RelistRequest } from "./types";

const RELIST_REQUESTS_URL = `${ORDERBOOK_URL}/relist-requests/`;

const getRelistRequest = async (
  relistRequestId: number,
): Promise<RelistRequest> => {
  return await makeSimpleGetRequest<RelistRequest>(
    `${RELIST_REQUESTS_URL}${relistRequestId}/`,
  );
};

export const useRelistRequest = (relistRequestId: number) => {
  return useQuery({
    queryKey: ["relistRequests", relistRequestId],
    queryFn: () => getRelistRequest(relistRequestId),
    retry: false,
    enabled: !!relistRequestId,
  });
};

export const createRelistRequest = async (
  payload: CreateRelistRequestPayload,
): Promise<RelistRequest> => {
  return await makeSimplePostRequest<RelistRequest>(
    RELIST_REQUESTS_URL,
    JSON.stringify(payload),
    [201],
  );
};
